import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class ClienteValidation extends DefaultValidation {

    constructor(msgs) {
        super(msgs);
    }

    validate (model, refs) {
        let valid = true;

        if (model.descricao.trim().length == 0) {
            refs.tituloInput.focusedOut = true;
            this.showMessage(new Message('error', 'msg-erro-titulo-vazio', true));
            valid = false;
        }

        return valid;
    }

}